import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LayoutState {
  modal: string;
  messageError: string;
  messageWarning: string;
  messageSuccess: string;
}

const initialState: LayoutState = {
  modal: "",
  messageError: "",
  messageWarning: "",
  messageSuccess: "",
};

export const layoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    setModal: (state, action: PayloadAction<string>) => {
      state.modal = action.payload;
    },
    setMessageError: (state, action: PayloadAction<string>) => {
      state.messageError = action.payload;
    },
    setMessageWarning: (state, action: PayloadAction<string>) => {
      state.messageWarning = action.payload;
    },
    setMessageSuccess: (state, action: PayloadAction<string>) => {
      state.messageSuccess = action.payload;
    },
    clearMessages: (state) => {
      state.messageError = "";
      state.messageWarning = "";
      state.messageSuccess = "";
    },
  },
});

export const LayoutActions = layoutSlice.actions;

export default layoutSlice.reducer;
